module.exports = __webpack_public_path__ + "static/media/card1.c3b1d774.svg";